function checkAnswerCorrectness(questions, answersByQuestionId) {
  const isCorrectByQuestionId = {}
  let correctCount = 0

  questions.forEach((question) => {
    const selectedOptionId = answersByQuestionId?.[question.id] ?? null
    const isCorrect = selectedOptionId !== null && selectedOptionId === question.correctOptionId
    isCorrectByQuestionId[question.id] = isCorrect
    if (isCorrect) correctCount += 1
  })

  return {
    total: questions.length,
    correctCount,
    isCorrectByQuestionId,
  }
}

function base64UrlEncode(text) {
  const bytes = new TextEncoder().encode(text)
  let binary = ''
  bytes.forEach((b) => {
    binary += String.fromCharCode(b)
  })
  return btoa(binary)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/g, '')
}

function base64UrlDecode(base64Url) {
  const base64 = base64Url
    .replace(/-/g, '+')
    .replace(/_/g, '/')

  const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=')
  const binary = atob(padded)
  const bytes = Uint8Array.from(binary, c => c.charCodeAt(0))
  return new TextDecoder().decode(bytes)
}

function encodeQuizResultsToParam(quizResults) {
  if (!quizResults || typeof quizResults !== 'object') return null

  const payload = {
    v: 1,
    total: Number(quizResults.total ?? 0),
    correctCount: Number(quizResults.correctCount ?? 0),
    isCorrectByQuestionId: quizResults.isCorrectByQuestionId ?? {},
  }

  return base64UrlEncode(JSON.stringify(payload))
}

function decodeQuizResultsFromParam(param) {
  if (!param || typeof param !== 'string') return null

  try {
    const decoded = base64UrlDecode(param)
    const payload = JSON.parse(decoded)

    if (!payload || typeof payload !== 'object') return null
    if (payload.v !== 1) return null

    const total = Number(payload.total)
    const correctCount = Number(payload.correctCount)
    const { isCorrectByQuestionId } = payload

    if (!Number.isFinite(total) || total <= 0) return null
    if (!Number.isFinite(correctCount) || correctCount < 0) return null
    if (!isCorrectByQuestionId || typeof isCorrectByQuestionId !== 'object') return null

    return {
      total,
      correctCount,
      isCorrectByQuestionId,
    }
  } catch (_err) {
    return null
  }
}

export {
  checkAnswerCorrectness,
  encodeQuizResultsToParam,
  decodeQuizResultsFromParam,
}
